var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { computedFrom } from "aurelia-binding";
import { autoinject, transient } from "aurelia-framework";
import { I18N } from "aurelia-i18n";
import { LookupValueRequest } from "../../../../../models/lookups/lookup.models";
import { NotificationClientService } from "../../../../../services/basics/notification-client.service";
import { LookupClientService } from "../../../../../services/lookups/lookup-client.service";
import { Guid } from "../../../../../utilities/guid";
import { ChildComponent } from "../../../../pages/modules/child-component";
var LotteryGrouping = /** @class */ (function (_super) {
    __extends(LotteryGrouping, _super);
    function LotteryGrouping(lookupClientService, notificationService, i18N) {
        var _this = _super.call(this, notificationService, i18N) || this;
        _this.lookupClientService = lookupClientService;
        _this.notificationService = notificationService;
        _this.i18N = i18N;
        _this._alreadySelectedLotteries = {};
        return _this;
    }
    Object.defineProperty(LotteryGrouping.prototype, "brandLotteryGroups", {
        get: function () {
            return this.item.brandLotteryGroups;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LotteryGrouping.prototype, "alreadySelectedLotteries", {
        get: function () {
            return this._alreadySelectedLotteries;
        },
        enumerable: false,
        configurable: true
    });
    LotteryGrouping.prototype.onActivated = function (model) {
        var _this = this;
        var self = this;
        var timerPromise = new Promise(function (resolve, reject) {
            setTimeout(function () {
                self._brandLotteries = null;
                resolve();
            });
        });
        return timerPromise.then(function (x) {
            _this.lookupClientService.getLookup(new LookupValueRequest("brandLotteries", _this.item.brandId.toString()))
                .then(function (x) {
                _this._brandLotteries = x.values;
            });
        });
    };
    Object.defineProperty(LotteryGrouping.prototype, "brandLotteries", {
        get: function () {
            return this._brandLotteries;
        },
        enumerable: false,
        configurable: true
    });
    LotteryGrouping.prototype.onLotteryDropdownChanged = function (selectedItem, index, group) {
        if (group && group.brandLotteryGroupItems) {
            var prevSelection = group.brandLotteryGroupItems[index];
            if (this.alreadySelectedLotteries && this.alreadySelectedLotteries[group.identifier] && prevSelection.brandLotteryId) {
                var itemToRemoveIndex = this.alreadySelectedLotteries[group.identifier].indexOf(prevSelection.brandLotteryId.toString());
                this._alreadySelectedLotteries[group.identifier].splice(itemToRemoveIndex, 1);
            }
        }
        if (selectedItem.detail.item && selectedItem.detail.item.additionalData['lotteryApiCode']) {
            var lookupItem_1 = selectedItem.detail.item;
            var apiCode_1 = lookupItem_1.additionalData['lotteryApiCode'];
            var itemsToExclude = this.brandLotteries.filter(function (x) { return x.additionalData['lotteryApiCode'] != apiCode_1 || x.id == lookupItem_1.id; }).map(function (x) { return x.id.toString(); });
            this.addToAlreadySelectedLotteries(group.identifier, itemsToExclude);
        }
        else if (group.brandLotteryGroupItems && group.brandLotteryGroupItems.length > 1) {
            var apiCode_2 = this.brandLotteries.filter(function (x) { return x.id == group.brandLotteryGroupItems[0].brandLotteryId; })[0].additionalData['lotteryApiCode'];
            var brandLotteriesToExclude = this.brandLotteries.filter(function (x) { return x.additionalData['lotteryApiCode'] != apiCode_2; }).map(function (x) { return x.id.toString(); });
            var itemsToExclude = group.brandLotteryGroupItems.map(function (x) { return x.brandLotteryId.toString(); }).concat(brandLotteriesToExclude);
            this.addToAlreadySelectedLotteries(group.identifier, itemsToExclude);
        }
    };
    LotteryGrouping.prototype.addToAlreadySelectedLotteries = function (identifier, listOfIds) {
        var item = [identifier];
        item = listOfIds;
        this._alreadySelectedLotteries[identifier] = item;
    };
    LotteryGrouping.prototype.addLottery = function (group) {
        if (!group.brandLotteryGroupItems)
            group.brandLotteryGroupItems = [];
        group.brandLotteryGroupItems.push({ brandLotteryGroupId: group.brandLotteryGroupId, brandLotteryId: 0 });
    };
    LotteryGrouping.prototype.removeLottery = function (group, index) {
        if (group.brandLotteryGroupItems.length <= 2) //remove only when the last item is deleted or when there is only one selection
            this._alreadySelectedLotteries[group.identifier] = [];
        group.brandLotteryGroupItems.splice(index, 1);
    };
    LotteryGrouping.prototype.addGroup = function () {
        this.item.brandLotteryGroups.push({
            brandId: this.item.brandId,
            brandLotteryGroupItems: [],
            lotteryGroupId: 0,
            identifier: Guid.generateGuid()
        });
    };
    LotteryGrouping.prototype.removeGroup = function (index) {
        this.item.brandLotteryGroups.splice(index, 1);
    };
    __decorate([
        computedFrom("item.brandLotteryGroups"),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], LotteryGrouping.prototype, "brandLotteryGroups", null);
    __decorate([
        computedFrom("_alreadySelectedLotteries"),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], LotteryGrouping.prototype, "alreadySelectedLotteries", null);
    __decorate([
        computedFrom("_brandLotteries"),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], LotteryGrouping.prototype, "brandLotteries", null);
    LotteryGrouping = __decorate([
        autoinject,
        transient(),
        __metadata("design:paramtypes", [LookupClientService, NotificationClientService,
            I18N])
    ], LotteryGrouping);
    return LotteryGrouping;
}(ChildComponent));
export { LotteryGrouping };
